import styled from 'styled-components';

const StyledChildrenContainer = styled.div`
    height: 100%;
`;

const StyledContainer = styled.div`
    width: 100%;
    background: #fff;
    padding-left: 1rem;
    padding-right: 1rem;
    min-height: 400px;
`;

const StyledContainerInner = styled.div`
    width: 100%;
    background: #efefef;
`;

export { StyledChildrenContainer, StyledContainer, StyledContainerInner };
